import vue from 'vue'
const that = vue.prototype
export default {
  className: 'feedBack',
  readonly: true,
  fields: [
    'user',
    'questionType',
    'opinion',
    'pictureCombination',
    'status'
  ],
  search: [
    'user',
    'questionType',
    'status'
  ],
  action: {
    create: false,
    edit: false,
    view: {
      type: 'row',
      text: '查看',
      viewTitle: '查看意见反馈',
      component: 'viewPage'
    },
    enter: {
      type: 'row',
      text: '标记已读',
      hidden ({ record, tags }) {
        if (record && record.status === 'processed') return true
      },
      callback: async ({ record, vm }) => {
        await vm.$modelAjax.put('feedBack', record.objectId, { status: 'processed' }).catch(() => {
          throw that.$notification['error']({
            message: '意见状态修改失败',
            description: '请重新尝试'
          })
        })
        that.$notification['success']({
          message: '意见状态已修改为已处理',
          description: '意见状态修改成功'
        })
        vm.refresh()
      }
    },
    hasEnter: {
      type: 'row',
      text: '已读',
      hidden ({ record, tags }) {
        if (record && record.status !== 'processed') return true
      },
      callback: async ({ vm }) => {
        throw that.$notification['error']({
          message: '建议状态为已处理状态',
          description: '请勿重复点击'
        })
      }
    }
  }
}
